import { render, staticRenderFns } from "./SelectShippingType.vue?vue&type=template&id=0cca85e1&"
import script from "./SelectShippingType.vue?vue&type=script&lang=ts&"
export * from "./SelectShippingType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports